export const FETCH_TRANSFER_ORDER_DETAIL_PENDING = "FETCH_TRANSFER_ORDER_DETAIL_PENDING";
export const FETCH_TRANSFER_ORDER_DETAIL_REJECTED = "FETCH_TRANSFER_ORDER_DETAIL_REJECTED";
export const FETCH_TRANSFER_ORDER_DETAIL_FULFILLED = "FETCH_TRANSFER_ORDER_DETAIL_FULFILLED";


// WEBPACK FOOTER //
// ./src/constants/kapidaConstants/transferOrderDetail.js